export default __webpack_public_path__ + "static/media/blubrry_3.65a3cad5.png";